<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [width]="class['text-connector-row']['width']" [device]="device" [elementChoosing]="objectChoosing"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình -->
      <li nz-submenu nzTitle="{{'cau_hinh' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <!-- Màu nền -->
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['text-connector-row']['background-color']"
            [style.background]="class['text-connector-row']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)"
            (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
        </div>
        <!-- Khoảng cách -->
        <div>
          <div class="config-name mb-0">
            <p>{{'khoang_cach' | translate}}</p>
            <nz-input-number [nzMin]="0" [nzMax]="50" [ngModel]="class['text-connector-row']['gap'] | vhnumber"
              (ngModelChange)="class['text-connector-row']['gap'] = $event + 'px'" (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider [nzMin]="0" [nzMax]="50" [ngModel]="class['text-connector-row']['gap'] | vhnumber "
                (ngModelChange)="class['text-connector-row']['gap'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </nz-col>
          </nz-row>
        </div>
        <div class="config-font">
          <p class="title"> {{'canh_le' | translate}}</p>
          <div class="font">
            <button class="font-text-btn" nz-button title="flex-start"
              [nzType]="class['text-connector-row']['align-items'] == 'flex-start' ? 'primary' : 'default'" (click)="
                class['text-connector-row']['align-items'] = 'flex-start';
                class['text-connector-row__line']['margin-bottom'] = '0px';
                updateClass();">
              <i nz-icon nzType="vertical-align-top" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button title="center"
              [nzType]="class['text-connector-row']['align-items'] == 'center' ? 'primary' : 'default'" (click)="
                class['text-connector-row']['align-items'] = 'center';
                class['text-connector-row__line']['margin-top'] = '0px';
                class['text-connector-row__line']['margin-bottom'] = '0px';
                updateClass();">
              <i nz-icon nzType="vertical-align-middle" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button title="flex-end"
              [nzType]="class['text-connector-row']['align-items'] == 'flex-end' ? 'primary' : 'default'" (click)="
                class['text-connector-row']['align-items'] = 'flex-end';
                class['text-connector-row__line']['margin-top'] = '0px';
                updateClass();">
              <i nz-icon nzType="vertical-align-bottom" nzTheme="outline"></i>
            </button>
          </div>
        </div>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text-connector-row']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <li nz-submenu nzTitle="{{'van_ban_bat_dau' | translate}}">
        <div class="editor-field">
          <div class="editor-field-body">
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['text-connector-row__text-start']"
              [textWrapperClass]="class['text-connector-row__text-start']" [isHideTextAlign]="true">
            </app-text-format-config>
          </div>
          <div class="field-row">
            <div class="config-font" style="margin-top:20px">
              <!-- Khoảng cách chữ -->
              <div>
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_chu' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50"
                    [ngModel]="class['text-connector-row__text-start']['letter-spacing'] | vhnumber"
                    (ngModelChange)="class['text-connector-row__text-start']['letter-spacing'] = $event+'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['text-connector-row__text-start']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['text-connector-row__text-start']['letter-spacing'] = $event+'px'"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                    [(ngModel)]="class['text-connector-row__text-start']['line-height']" (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="class['text-connector-row__text-start']['line-height']"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li nz-submenu nzTitle="{{'duong_ke' | translate}}">
        <div class="item-border">
          <p class="m-0 title-border">{{'kieu_vien' | translate}}</p>
          <div class="field-widget">
            <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menuBorder" nzPopoverTrigger="click">
              <mat-icon>border_style</mat-icon>
            </button>
          </div>
          <!-- Menu các kiểu viền khác -->
          <nz-dropdown-menu #menuBorder="nzDropdownMenu">
            <ul nz-menu>
              <!-- Kiểu viền solid -->
              <li nz-menu-item>
                <button (click)="class['text-connector-row__line']['border-style']  = 'solid'; updateClass()" nz-tooltip
                  nzTooltipTitle="Solid" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['text-connector-row__line']['border-style']  == 'solid'}">
                  <div class="icon-field">
                    <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                        fill="#000000" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền double -->
              <li nz-menu-item>
                <button (click)="class['text-connector-row__line']['border-style']  = 'double'; updateClass()"
                  nz-tooltip nzTooltipTitle="Double" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['text-connector-row__line']['border-style']  == 'double'}">
                  <div class="icon-field">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-border-style" viewBox="0 0 16 16">
                      <path
                        d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dashed -->
              <li nz-menu-item>
                <button (click)="class['text-connector-row__line']['border-style']  = 'dashed'; updateClass()"
                  nz-tooltip nzTooltipTitle="Dashed" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['text-connector-row__line']['border-style']  == 'dashed'}">
                  <div class="icon-field">
                    <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                        fill="#000000" />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dotted -->
              <li nz-menu-item>
                <button (click)="class['text-connector-row__line']['border-style']  = 'dotted'; updateClass()"
                  nz-tooltip nzTooltipTitle="Dotted" nzTooltipPlacement="left" class="widget-button"
                  [ngClass]="{'active': class['text-connector-row__line']['border-style']  == 'dotted'}">
                  <div class="icon-field">
                    <i class="bi bi-three-dots"></i>
                  </div>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
        <div class="item-border-size">
          <!-- Điều chỉnh kích thước viền dưới -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5;">{{'kich_thuoc_vien' | translate}}</p>
            <nz-input-number [nzMin]="0" [nzMax]="10" [ngStyle]="{ marginLeft: '16px',width: '40%' }"
              [ngModel]="class['text-connector-row__line']['border-bottom-width'] | vhnumber" (nzBlur)="updateClass()"
              (ngModelChange)="class['text-connector-row__line']['border-bottom-width'] = $event +'px'"></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider [nzMin]="0" [nzMax]="10"
                [ngModel]="class['text-connector-row__line']['border-bottom-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['text-connector-row__line']['border-bottom-width'] = $event +'px'"></nz-slider>
            </nz-col>
          </nz-row>
        </div>
        <!-- Màu cơ bản -->
        <div class="item-border">
          <p class="m-0 title-border">{{'mau_vien' | translate}}</p>
          <div class="color-pick">
            <input class="border-config__gradient-input" type="button" [cpOKButton]="true"
              [style.background]="class['text-connector-row__line']['border-color']"
              [(colorPicker)]="class['text-connector-row__line']['border-color']" (colorPickerClose)="updateClass()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
          </div>
        </div>
        <!-- Khoảng cách bên dưới/trên -->
        <ng-container *ngIf="class['text-connector-row']['align-items'] != 'center'">
          <div *ngIf="class['text-connector-row']['align-items'] == 'flex-start'">
            <div class="config-name mb-0">
              <p>
                {{ ('khoang_cach_ben_tren' ) | translate }}
              </p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [ngModel]="class['text-connector-row__line']['margin-top'] | vhnumber"
                (ngModelChange)="class['text-connector-row__line']['margin-top'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['text-connector-row__line']['margin-top'] | vhnumber"
                  (ngModelChange)="class['text-connector-row__line']['margin-top'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div *ngIf="class['text-connector-row']['align-items'] == 'flex-end'">
            <div class="config-name mb-0">
              <p>
                {{ ('khoang_cach_ben_duoi' ) | translate }}
              </p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [ngModel]="class['text-connector-row__line']['margin-bottom'] | vhnumber"
                (ngModelChange)="class['text-connector-row__line']['margin-bottom'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['text-connector-row__line']['margin-bottom'] | vhnumber"
                  (ngModelChange)="class['text-connector-row__line']['margin-bottom'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </ng-container>
      </li>
      <li nz-submenu nzTitle="{{'van_ban_ket_thuc' | translate}}">
        <div class="editor-field">
          <div class="editor-field-body">
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['text-connector-row__text-end']"
              [textWrapperClass]="class['text-connector-row__text-end']" [isHideTextAlign]="true">
            </app-text-format-config>
          </div>
          <div class="field-row">
            <div class="config-font" style="margin-top:20px">
              <!-- Khoảng cách chữ -->
              <div>
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_chu' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50"
                    [ngModel]="class['text-connector-row__text-end']['letter-spacing'] | vhnumber"
                    (ngModelChange)="class['text-connector-row__text-end']['letter-spacing'] = $event+'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['text-connector-row__text-end']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['text-connector-row__text-end']['letter-spacing'] = $event+'px'"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name mb-0">
                  <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                    [(ngModel)]="class['text-connector-row__text-end']['line-height']" (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="class['text-connector-row__text-end']['line-height']"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-connector-row']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>

      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle=" {{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 0">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text-connector-row']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>